export default __webpack_public_path__ + "static/media/BGF2024_bg1.7882fad0.jpg";